import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
// Redux
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import CountDown from '../../CountDown';
import Link from '../../Link';
import fetch from '../../../core/fetch';
import messages from '../../../locale/jsonMessages';
import { bookingProcess } from '../../../actions/booking/bookingProcess';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const GuestActions = (props) => {

    const dispatch = useDispatch();

    const preBook = async () => {
        const { listId, startDate, endDate, personCapacity, listPublishStatus, startTime, endTime, threadId, getInquiry } = props;
        const preApprove = true;
        let query = `query checkReservation ($checkIn: String,$checkOut: String,$listId: Int ){
            checkReservation(checkIn: $checkIn, checkOut:$checkOut, listId:$listId ){
              id
              listId
              hostId
              guestId
              checkIn
              checkOut
              status
            }
          }`;

        const params = {
            listId: listId,
            checkIn: moment(parseInt(startDate)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            checkOut: moment(parseInt(endDate)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        };

        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query,
                variables: params,
            }),
            credentials: 'include',
        });

        const { data } = await resp.json();
        if (data && data.checkReservation) {
            if (data.checkReservation.status == "200") {
                if (listPublishStatus) {
                    dispatch(bookingProcess({ listId, guests: personCapacity, startDate: moment(parseInt(startDate)), endDate: moment(parseInt(endDate)), preApprove, startTime, endTime, threadId, getInquiry }))
                } else {
                    showToaster({ messageId: 'listingUnPublish', toasterType: 'error' })
                }
            }
            else {
                showToaster({ messageId: 'bookingFailed', toasterType: 'error' })
            }
        }
    }

    // Inquiry
    const inquiry = (hostDisplayName) => {
        const { listId } = props;
        return (
            <div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
                <h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.messageAction1} /> {hostDisplayName} <FormattedMessage {...messages.messageAction2} /></h4>
                <p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
                    <FormattedMessage {...messages.messageActionInfo} />
                </p>
                <div>
                    <Link to={"/cars/" + listId} className={cx(s.linkBtn, s.btnPrimary, s.linkInline)}><FormattedMessage {...messages.requestToBook} /></Link>
                </div>
            </div>
        );
    }

    // Request to book
    const requestToBook = (hostDisplayName) => {
        const { reservationId } = props;
        return (
            <div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
                <h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.messageAction3} /> {hostDisplayName} <FormattedMessage {...messages.messageAction4} /></h4>
                <p className={cx(s.actionPara, s.noMarginTop, s.marginBottom0)}>
                    <FormattedMessage {...messages.cancelInfoBooking} />
                </p>
            </div>
        );
    }

    // Request to book / Pre-approved by host
    const approved = (hostDisplayName) => {
        const { createdAt } = props;
        let startDate = moment();
        let next24Hours = moment(parseInt(createdAt)).add(23, 'hours').add(59, 'minutes');
        let distance = Number(next24Hours - startDate);
        let options = { endDate: next24Hours };
        if (distance < 0) {
            return expired();
        } else {
            return (
                <div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
                    <h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.requestApprovedAction1} /> {hostDisplayName} <FormattedMessage {...messages.messageAction4} /></h4>
                    <p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
                        <FormattedMessage {...messages.requestTimeInfo1} /> <CountDown options={options} /> <FormattedMessage {...messages.requestTimeInfo2} />
                    </p>
                    <div className={cx()}>
                        <Button className={s.btnPrimary} onClick={() => preBook()}>
                            <FormattedMessage {...messages.book} />
                        </Button>
                    </div>
                </div>
            );
        }
    }

    // Booking confirmed by host/ instant booking
    const bookingConfirmed = (hostDisplayName) => {
        const { reservationId } = props;
        return (
            <div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
                <h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}>
                    <FormattedMessage {...messages.bookingConfirmedInfo1} /> {hostDisplayName} <FormattedMessage {...messages.messageAction4} />
                </h4>
                <p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
                    <FormattedMessage {...messages.bookingCanceledInfo} />
                </p>
                <div className={cx()}>
                    <Link to={"/cancel/" + reservationId + "/renter"} className={cx(s.linkBtn, s.btnPrimary, s.linkInline)}>
                        <FormattedMessage {...messages.cancelTrip} />
                    </Link>
                </div>
            </div>
        );
    }

    // Pre-approved or approved by host is expired
    const expired = () => {
        const { listId } = props;
        return (
            <div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
                <h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.bookingExpiredTitle} /></h4>
                <p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
                    <FormattedMessage {...messages.bookingExpiredInfo} />
                </p>
                <div className={cx()}>
                    <Link to={"/cars/" + listId} className={cx(s.linkBtn, s.btnPrimary, s.linkInline)}>
                        <FormattedMessage {...messages.gotoListing} />
                    </Link>
                </div>
            </div>
        );
    }

    const { actionType, hostDisplayName } = props;

    if (actionType === 'inquiry') {
        return inquiry(hostDisplayName);
    }
    else if (actionType === 'preApproved') {
        return approved(hostDisplayName);
    } else if (actionType === 'intantBooking' || actionType === 'approved') {
        return bookingConfirmed(hostDisplayName);
    } else if (actionType === 'requestToBook') {
        return requestToBook(hostDisplayName);
    } else return <div />;
}

GuestActions.propTypes = {
    actionType: PropTypes.string.isRequired,
    hostDisplayName: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    personCapacity: PropTypes.number.isRequired,
    listId: PropTypes.number.isRequired,
    reservationId: PropTypes.number,
    formatMessage: PropTypes.any,
};

export default withStyles(cs, s)(GuestActions);